var inquiry_animationStep = Number();
window.inquiry_config = {
  collapsibleAttr: 'data-collapsible-form-open',
  standardOffset: 20
};
function inquiry_isElementIdValid(elementId) {
  return elementId && typeof elementId === 'string' && elementId.length > 0;
}
function inquiry_getHeaderSize() {
  var e = document.getElementsByTagName('header')[0];
  if (!e) return 0;
  return e.offsetHeight || 0;
}
window.inquiry_scrollToElement = function(formId, customOffset, blockId) {
  if (!inquiry_isElementIdValid(formId)) return;
  var element = document.getElementById(blockId),
    rect = element ? element.getBoundingClientRect() : null,
    extraOffset = inquiry_config.standardOffset + (customOffset || 0),
    topPosition = rect ? rect.top + document.documentElement.scrollTop : 0;
  window.scrollTo({ top: topPosition - inquiry_getHeaderSize() - extraOffset, behavior: 'smooth' });
}
window.inquiry_toggleFormOpenAttribute = function(formId, open) {
  if (!inquiry_isElementIdValid(formId)) {
    return
  };
  var formElement = document.getElementById(formId);
  if (!formElement) {
    return
  };
  var targetOpen = Boolean();
  switch (open) {
    case typeof open === 'boolean':
      targetOpen = open;
      break;
    default:
      targetOpen = !Boolean(formElement.getAttribute(inquiry_config.collapsibleAttr) === 'true');
  }
  formElement.setAttribute(inquiry_config.collapsibleAttr, String(targetOpen));
  var iframeElement = formElement.querySelector('iframe');
  if (!iframeElement) {
    return;
  }
  if (targetOpen) {
    iframeElement.removeAttribute('tabindex');
  }
  else {
    iframeElement.setAttribute('tabindex', '-1');
  }
  

  return targetOpen;
}

function inquiry_setIntroductionLink() {
  var introductionBlockLink = document.querySelector('.introduction-text-block__contact-sales-link');
  var linkWrapper = document.querySelector('.inquiry-contact-link');
  if (!linkWrapper || !introductionBlockLink) return;

  if (!linkWrapper.children.length) return;

  var link = linkWrapper.children[0];
  introductionBlockLink.textContent = '';
  introductionBlockLink.appendChild(linkWrapper);
  linkWrapper.style.display = 'block';

  link.addEventListener('click', function (event) {
    event.preventDefault();

    var formId = link.getAttribute('data-formId');
    var blockId = link.getAttribute('data-blockId');
    
    if (document.getElementById(formId).classList.contains('js-industry-sales-form')) {
      industrySales_verticalBtnFn(formId, blockId);
    }
    else {
      inquiry_verticalBtnFn(formId, blockId);
    }
  });
}
setTimeout(inquiry_setIntroductionLink, 100);